module.exports = __webpack_public_path__ + "7787423d82f6f8cecd82b7ff5b29dca6.svg";